/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiSearchFilter } from './InternalApiSearchFilter';
import {
    InternalApiSearchFilterFromJSON,
    InternalApiSearchFilterFromJSONTyped,
    InternalApiSearchFilterToJSON,
    InternalApiSearchFilterToJSONTyped,
} from './InternalApiSearchFilter';
import type { InternalApiLogicalOperator } from './InternalApiLogicalOperator';
import {
    InternalApiLogicalOperatorFromJSON,
    InternalApiLogicalOperatorFromJSONTyped,
    InternalApiLogicalOperatorToJSON,
    InternalApiLogicalOperatorToJSONTyped,
} from './InternalApiLogicalOperator';
import type { InternalApiSortDirection } from './InternalApiSortDirection';
import {
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionFromJSONTyped,
    InternalApiSortDirectionToJSON,
    InternalApiSortDirectionToJSONTyped,
} from './InternalApiSortDirection';

/**
 * 
 * @export
 * @interface InternalApiFindCaseHandlesRequest
 */
export interface InternalApiFindCaseHandlesRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalApiFindCaseHandlesRequest
     */
    orderBy?: string;
    /**
     * 
     * @type {InternalApiSortDirection}
     * @memberof InternalApiFindCaseHandlesRequest
     */
    direction?: InternalApiSortDirection;
    /**
     * 
     * @type {Array<InternalApiSearchFilter>}
     * @memberof InternalApiFindCaseHandlesRequest
     */
    filters: Array<InternalApiSearchFilter>;
    /**
     * 
     * @type {InternalApiLogicalOperator}
     * @memberof InternalApiFindCaseHandlesRequest
     */
    logicalOperator: InternalApiLogicalOperator;
}



/**
 * Check if a given object implements the InternalApiFindCaseHandlesRequest interface.
 */
export function instanceOfInternalApiFindCaseHandlesRequest(value: object): value is InternalApiFindCaseHandlesRequest {
    if (!('filters' in value) || value['filters'] === undefined) return false;
    if (!('logicalOperator' in value) || value['logicalOperator'] === undefined) return false;
    return true;
}

export function InternalApiFindCaseHandlesRequestFromJSON(json: any): InternalApiFindCaseHandlesRequest {
    return InternalApiFindCaseHandlesRequestFromJSONTyped(json, false);
}

export function InternalApiFindCaseHandlesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiFindCaseHandlesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'orderBy': json['orderBy'] == null ? undefined : json['orderBy'],
        'direction': json['direction'] == null ? undefined : InternalApiSortDirectionFromJSON(json['direction']),
        'filters': ((json['filters'] as Array<any>).map(InternalApiSearchFilterFromJSON)),
        'logicalOperator': InternalApiLogicalOperatorFromJSON(json['logicalOperator']),
    };
}

export function InternalApiFindCaseHandlesRequestToJSON(json: any): InternalApiFindCaseHandlesRequest {
    return InternalApiFindCaseHandlesRequestToJSONTyped(json, false);
}

export function InternalApiFindCaseHandlesRequestToJSONTyped(value?: InternalApiFindCaseHandlesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderBy': value['orderBy'],
        'direction': InternalApiSortDirectionToJSON(value['direction']),
        'filters': ((value['filters'] as Array<any>).map(InternalApiSearchFilterToJSON)),
        'logicalOperator': InternalApiLogicalOperatorToJSON(value['logicalOperator']),
    };
}

